export const formatToK = (value: number) => {
  if (value >= 1000) {
    return (value / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return value.toString();
};

export const isValidImage = (url: string) => {
  const validExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".svg"];
  return validExtensions.some(
    (ext) => url?.endsWith(ext) || url?.includes(ext)
  );
};

export const getValidImageUrl = (url: string, defaultImage: string): string => {
  if (!url) return defaultImage;

  if (url.startsWith("ipfs://")) {
    // Handle IPFS URLs by converting them to an HTTP gateway
    url = convertIpfsToHttp(url);
  } else if (url.startsWith("ar://")) {
    // Convert Arweave URL to HTTP
    url = convertArweaveToHttp(url);
  } else if (url.startsWith("https://")) {
    url = convertArweaveToHttp(url);
  } else {
    url = "https://ipfs.io/ipfs/" + url;
  }

  // console.log('current url', url);

  return url;
};

// Convert IPFS URL to an HTTP gateway URL
export const convertIpfsToHttp = (ipfsUrl: string): string => {
  return ipfsUrl.replace("ipfs://", "https://ipfs.io/ipfs/");
  // return ipfsUrl.replace("ipfs://", "https://gateway.pinata.cloud/ipfs/");
};

// Convert Arweave URL
export const convertArweaveToHttp = (arweaveUrl: string): string => {
  return arweaveUrl.replace("ar://", "https://arweave.net/");
};
